// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"79":"49298059","82":"eaa3b536","226":"ad7ed645","351":"4562ae44","416":"15bc0203","477":"108ddac6","787":"ea386385","852":"18efb7c8"}[chunkId] + ".js";
};